import React, { useState, useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Header, Button, Grid, Table, Dimmer, Loader } from "semantic-ui-react";
import { ReactSVG } from "react-svg";
import _ from 'lodash';
import { AddressBookModel } from '../../types/AddressBookDTO';
import DocumentAdd from "../../assets/images/document-add.svg";
import UserInfo from '../Common/SharedComponents/UserInfo';
import AdminSidebar from '../Common/SharedComponents/AdminSidebar';
import AppContext, { token_config } from '../../AppContext';
import axiosInstance from '../../helpers/axiosInstance';
import SwitchTheme from '../Common/SharedComponents/SwitchTheme';

const AddressBooks: React.FC = () => {
  const navigate = useNavigate();
  const { userInfo } = useContext(AppContext);

  useEffect(() => {
    if (userInfo !== undefined) {
      const privileges: string[] = userInfo ? userInfo.Privileges.split(',') : [];
      if (!privileges.includes(token_config.MANAGE_ADDRESS_BOOKS)) {
        navigate('/');
      }
    }
  }, [userInfo, navigate]);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [addressBooks, setAddressBooks] = useState<AddressBookModel[] | null>(null);

  useEffect(() => {
    document.title = 'Address Book - Adjure';
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      await axiosInstance.get(`/AdminSetting/GetAddressBook`).then(({ data, status }) => {
        if (status === 200) {
          setAddressBooks(data);
        }
        setIsLoading(false);
      })
        .catch((error) => {
          setIsLoading(false);
          console.log(error);
        });
    } catch (error: any) {
      setIsLoading(false);
      console.log(error);
    }
  }

  return (
    <section className="section" style={{
      minHeight: '100vh'
    }}>
      <div className="section__head">
        <div className="section__head-content">
          <Header as="h1">Address Book</Header>
        </div>
        <div className="section__actions">
          <UserInfo />
          <Button color="violet" onClick={() => navigate('/address_book')}>
            <Button.Content visible style={{ whiteSpace: 'nowrap' }}>
              Add Email
            </Button.Content>
            <Button.Content visible>
              <ReactSVG src={DocumentAdd} />
            </Button.Content>
          </Button>
          <SwitchTheme />
        </div>
      </div>
      <div className="section__body">
        <Dimmer.Dimmable as="div" dimmed={isLoading}>
          <Dimmer active={isLoading} inverted={true}>
            <Loader>Loading</Loader>
          </Dimmer>
          <Grid padded>
            <Grid.Row>
              <Grid.Column mobile={16} tablet={3} computer={3}>
                <AdminSidebar />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={13} computer={13}>
                <div className='table-holder'>
                  <Table celled={true} sortable={true} striped={true}>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>
                          Email
                        </Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      {addressBooks && addressBooks.length > 0 && addressBooks.map((row) => (
                        <Table.Row key={row.email}>
                          <Table.Cell style={{ textAlign: 'left', fontSize: '16px' }}><Link to={`/address_book/${row.id}`}>{row.email}</Link></Table.Cell>
                        </Table.Row>
                      ))}
                      {(!addressBooks || addressBooks.length === 0) &&
                        <Table.Row key={1}>
                          <Table.Cell key={2}><p style={{ fontSize: '1.5em' }}>No email(s) to display</p></Table.Cell>
                        </Table.Row>
                      }
                    </Table.Body>
                  </Table>
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Dimmer.Dimmable>
      </div>
    </section>
  );
}

export default AddressBooks;